export interface Casino {
  rank: number;
  name: string;
  description: string;
  rating: number;
  bonus: string;
  games: string;
  gameLibrary?: {
    totalGames?: string;
    providers?: string;
    exclusives?: string;
    liveTables?: string;
  };
  minDeposit: string;
  payoutSpeed: string;
  logo: string;
  featured: boolean;
  tags?: string[];
  pros?: string[];
  cons?: string[];
  licenses?: string[];
  paymentMethods?: string[];
  softwareProviders?: string[];
  trustScore?: {
    safety: number;
    bonuses: number;
    games: number;
    support: number;
  };
  editorNote?: string;
  trustScores?: {
    safety: number;
    bonuses: number;
    games: number;
    support: number;
  };
}

export const casinos: Casino[] = [
  {
    rank: 1,
    name: 'iPay9vip Online Casino',
    description: 'iPay9vip is an exclusive VIP destination built from the iPay9 ecosystem, offering elevated rewards, richer bonus layers, and premium member benefits while bringing together popular slot game series and football event-inspired features for a more immersive and exciting online entertainment experience.',
    rating: 4.93,
    bonus: 'Welcome Bonus 100% + Unlimited Sportsbook Rebate',
    games: '4,500+',
    gameLibrary: {
      totalGames: '4,500+',
      providers: '52+',
      exclusives: '22+',
      liveTables: '15+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/ipay9vip.png',
    featured: true,
    tags: ['Top Picks', 'Best for Games', 'VIP Exclusive'],
    pros: ['VIP-first service experience', 'More exclusive bonuses and member welfare', 'Access to famous and trending slot series', 'World Cup options ready for football fans'],
    cons: ['Most top-value perks are focused on active VIP members', 'Campaign availability can vary by season and event schedule'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 96,
      bonuses: 95,
      games: 96,
      support: 95
    },
    editorNote: 'iPay9vip is a strong fit for bonus-seeking VIP users who want premium treatment, top slot coverage, and added flexibility during major football seasons.',
  },
  {
    rank: 2,
    name: 'MrBoom9 Online Casino',
    description:
      'MrBoom9 offers a bonus-rich experience with a highly rewarding welcome journey, supported by smooth, lag-free gameplay, enhanced visuals, and secure payment options for a more reliable and enjoyable online entertainment experience.',
    rating: 4.87,
    bonus: 'Register Instant Free $99.99 + Daily Free $20',
    games: '4,500+',
    gameLibrary: {
      totalGames: '4,500+',
      providers: '48+',
      exclusives: '18+',
      liveTables: '12+',
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/mrboom9.png',
    featured: true,
    tags: ['Best New', 'Best AUS', 'Top Picks', 'Best for Games'],
    pros: [
      'Extraordinary bonus focus with strong new-player rewards',
      'Smooth sessions with minimal lag in our testing',
      'Sharper visuals and HD-friendly game presentation where available',
      'Safer, well-rounded payment options for deposits and cashouts',
      'Regular intake of new releases for variety seekers',
    ],
    cons: [
      'Newer brand with a shorter track record than established operators',
      'Some promos may update frequently—always read the latest terms',
    ],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 95,
      bonuses: 97,
      games: 93,
      support: 94,
    },
    editorNote:
      'MrBoom9 stands out for bonus-led value and a polished feel for a new launch—ideal if you want generous starter rewards without sacrificing smooth play and modern payment safety.',
  },
  {
    rank: 3,
    name: 'iPay9 Online Casino',
    description: 'iPay9 is a well-established premium online casino known for its strong reputation and consistent performance, offering a deep game lobby, exclusive content, and competitive promotions, making it a strong choice for players who want variety and bonus value without compromising platform stability.',
    rating: 4.84,
    bonus: 'Slot Game Bonus 110% + Daily Checkin Bonus',
    games: '4,500+',
    gameLibrary: {
      totalGames: '4,500+',
      providers: '50+',
      exclusives: '19+',
      liveTables: '14+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/ipay9.png',
    featured: true,
    tags: ['Best AUS', 'Top Picks', 'Best for Games'],
    pros: ['Massive game selection', 'Fast withdrawals', 'Excellent mobile app', '24/7 customer support'],
    cons: ['Some promotions carry above-average wagering requirements', 'VIP cashback terms are less competitive on lower tiers'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 98,
      bonuses: 95,
      games: 99,
      support: 97
    },
    editorNote: 'iPay9 is one of the most dependable high-volume platforms we tested, combining deep game variety with reliable payouts and responsive support.',
  },
  {
    rank: 4,
    name: 'Kingbet9 Online Casino',
    description: 'Kingbet9 combines broad game selection with reliable payout processing and a customer support team that performs well under real testing. It suits players who want an all-round experience with fewer day-to-day friction points.',
    rating: 4.81,
    bonus: 'Daily Task Free $100 + Share Bonus $180',
    games: '4,500+',
    gameLibrary: {
      totalGames: '4,500+',
      providers: '50+',
      exclusives: '18+',
      liveTables: '13+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/kingbet9.png',
    featured: true,
    tags: ['Best AUS', 'Best for Games'],
    pros: ['Excellent customer service', 'Wide game variety', 'Regular tournaments', 'Generous free spins'],
    cons: ['Bonus structures can feel complex for first-time players', 'Popular live tables can fill up during peak hours'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 98,
      bonuses: 96,
      games: 95,
      support: 99
    },
    editorNote: 'Kingbet9 stands out for service quality and operational consistency, making it a trustworthy option for players who value smooth day-to-day play.',
  },
  {
    rank: 5,
    name: 'BigPay77 Online Casino',
    description: 'BigPay77 focuses on frequent campaigns, tournament activity, and an easy-to-use lobby with a large game catalog. It is particularly appealing to bonus-driven players who still want practical banking speed.',
    rating: 4.78,
    bonus: 'Up to 80% Pokies Welcome Bonus',
    games: '4,000+',
    gameLibrary: {
      totalGames: '4,000+',
      providers: '50+',
      exclusives: '17+',
      liveTables: '12+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/bp77.png',
    featured: true,
    tags: ['Best AUS', 'Top Picks'],
    pros: ['Low minimum deposit', 'Daily promotions', 'User-friendly interface', 'Fast withdrawals'],
    cons: ['Game catalog depth is lower than top-tier rivals', 'Live dealer variety is solid but not market-leading'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 97,
      bonuses: 94,
      games: 92,
      support: 95
    },
    editorNote: 'BigPay77 delivers strong practical value through low entry costs, frequent campaigns, and quick withdrawals that hold up in repeated testing.',
  },
  {
    rank: 6,
    name: 'Me99 Online Casino',
    description: 'Me99 is an established brand known for high trust scores, strong promotional depth, and consistently quick withdrawal handling. It is best for players looking for a premium-feeling platform with dependable core performance.',
    rating: 4.75,
    bonus: 'Up to A$220.99 Starter Pack',
    games: '4,300+',
    gameLibrary: {
      totalGames: '4,300+',
      providers: '50+',
      exclusives: '16+',
      liveTables: '11+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/me99.png',
    featured: true,
    tags: ['Best AUS', 'Top Picks', 'Best for Games'],
    pros: ['Huge welcome bonus', 'Trusted brand name', 'Lightning-fast payouts', 'VIP rewards program'],
    cons: ['VIP perks are more rewarding for high-frequency players', 'Bonus turnover can be demanding on selected campaigns'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 99,
      bonuses: 98,
      games: 98,
      support: 96
    },
    editorNote: 'Me99 performs like a premium operator, with top-tier safety scores, strong bonus value, and payout speeds that consistently meet expectations.',
  },
  {
    rank: 7,
    name: 'Gucci9 Online Casino',
    description: 'Gucci9 offers a trend-forward lobby with colorful slot coverage, active live casino tables, and regular content updates. It is ideal for players who want a modern look, fresh releases, and balanced session variety.',
    rating: 4.72,
    bonus: 'Free $1999 for #1 Ranking Deposit',
    games: '4,300+',
    gameLibrary: {
      totalGames: '4,300+',
      providers: '50+',
      exclusives: '19+',
      liveTables: '8+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/gucci9.png',
    featured: true,
    tags: ['Best AUS', 'Best for Games', 'Top Picks'],
    pros: ['Stylish and intuitive UI', 'Strong live casino selection', 'Frequent new game drops', 'Responsive support team'],
    cons: ['Wagering terms vary noticeably between campaigns', 'Support response times can slow down during evening peaks'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 95,
      bonuses: 93,
      games: 94,
      support: 92
    },
    editorNote: 'Gucci9 delivers a strong modern package with quality live content, frequent game updates, and payment reliability that supports long-term use.',
  },
  {
    rank: 8,
    name: 'Rolex9 Online Casino',
    description: 'Rolex9 delivers a luxury-style experience with refined design, stable gameplay flow, and broad cross-device compatibility. It works well for players who care about presentation as much as game depth.',
    rating: 4.69,
    bonus: 'Register Free Credit A$99.99 + $10 Free Bet',
    games: '4,400+',
    gameLibrary: {
      totalGames: '4,400+',
      providers: '50+',
      exclusives: '15+',
      liveTables: '10+'
    },
    minDeposit: '$19',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/rolex9.png',
    featured: true,
    tags: ['Best AUS', 'Top Picks', 'Best for Games'],
    pros: ['Elegant and modern interface', 'Large game variety', 'Reliable withdrawal processing', 'Great mobile compatibility'],
    cons: ['Promotion quality can vary significantly week to week', 'Top-value offers often have tighter completion windows'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 96,
      bonuses: 92,
      games: 95,
      support: 94
    },
    editorNote: 'Rolex9 combines premium presentation with stable performance, and it remains one of the most reliable choices for balanced gameplay and payments.',
  },
  {
    rank: 9,
    name: 'Bybid9 Online Casino',
    description: 'Bybid9 is a promotion-first casino built around daily rewards, recurring campaigns, and high-energy slot content. It is a good option for players who enjoy frequent incentives and a familiar classic-casino rhythm.',
    rating: 4.66,
    bonus: 'Up to $288 Free Chips Bonus',
    games: '4,500+',
    gameLibrary: {
      totalGames: '4,500+',
      providers: '50+',
      exclusives: '20+',
      liveTables: '9+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/bybid9.png',
    featured: true,
    tags: ['Top Picks', 'Best for Games'],
    pros: ['Exclusive jackpot network', 'Classic casino feel', 'Loyalty rewards', 'Regular promotions'],
    cons: ['Withdrawal processing is less consistent on weekends', 'Interface flow feels dated in a few account sections'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 96,
      bonuses: 93,
      games: 91,
      support: 94
    },
    editorNote: 'Bybid9 is a solid pick for players who prioritize promotions and familiar casino flow, with dependable fundamentals across security and support.',
  },
  {
    rank: 10,
    name: 'MrBean9 Online Casino',
    description: 'MrBean9 takes a fun-first approach with MrBean cartoon themes, straightforward navigation, and low-friction onboarding. It is a practical pick for casual players who want easy entry and consistent weekly offers.',
    rating: 4.63,
    bonus: 'Up to $222.99 + 200% Welcome Bonus',
    games: '4,000+',
    gameLibrary: {
      totalGames: '4,000+',
      providers: '50+',
      exclusives: '17+',
      liveTables: '6+'
    },
    minDeposit: '$5',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/mrbean9.png',
    featured: true,
    tags: ['Best AUS', 'Top Picks'],
    pros: ['Beginner-friendly navigation', 'Unique game themes', 'Consistent weekly campaigns', 'Low-friction onboarding'],
    cons: ['VIP progression benefits are lighter than premium competitors', 'Payout speed can fluctuate depending on method and queue volume'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 93,
      bonuses: 92,
      games: 91,
      support: 93
    },
    editorNote: 'MrBean9 is a convincing casual-friendly option, pairing easy onboarding with consistent weekly offers and dependable core performance.',
  },
  {
    rank: 11,
    name: 'Spinaroo Online Casino',
    description: 'Spinaroo emphasizes mission systems, tournament participation, and challenge-based progression for engaged players. It is best suited to users who prefer structured goals and event-driven gameplay loops.',
    rating: 4.61,
    bonus: 'Up to A$199.99 + 80% Welcome Bonus',
    games: '4,000+',
    gameLibrary: {
      totalGames: '4,000+',
      providers: '50+',
      exclusives: '18+',
      liveTables: '7+'
    },
    minDeposit: '$8',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/spinaroo.png',
    featured: true,
    tags: ['Top Picks', 'Best for Games'],
    pros: ['Excellent tournament ecosystem', 'Daily mission rewards', 'Smooth app performance', 'Broad payment support'],
    cons: ['Feature-heavy layout can overwhelm new players initially', 'Tournament schedules can be restrictive for casual players'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 94,
      bonuses: 91,
      games: 93,
      support: 92
    },
    editorNote: 'Spinaroo is highly competitive for mission and tournament players, with a structure that rewards frequent play without sacrificing platform stability.',
  },
  {
    rank: 12,
    name: 'Winnie777 Online Casino',
    description: 'Winnie777 combines a beginner-friendly layout with a large slot library and a promotion-heavy campaign schedule. It is well suited to players who value simple navigation, frequent offers, and broad content access.',
    rating: 4.57,
    bonus: 'Up to A$122 + 3 Free Spins',
    games: '4,500+',
    gameLibrary: {
      totalGames: '4,500+',
      providers: '50+',
      exclusives: '15+',
      liveTables: '12+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/winnie777.png',
    featured: true,
    tags: ['Top Picks', 'Best for Games', 'Best AUS'],
    pros: ['Large slot catalog', 'Loyalty perks for active players', 'Regular campaign updates', 'Beginner-friendly lobby layout'],
    cons: ['Bonus terms can change materially between campaign cycles', 'Top promotions may require frequent opt-in tracking'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 97,
      bonuses: 94,
      games: 96,
      support: 93
    },
    editorNote: 'Winnie777 is a practical recommendation for beginners and promo-focused players, with broad slot coverage and a straightforward user experience.',
  },
  {
    rank: 13,
    name: 'Micky9 Online Casino',
    description: 'Micky9 is a balanced all-rounder that pairs a solid game library with predictable payouts and clear user flow. It is a dependable choice for players who want consistency over flashy but uneven features.',
    rating: 4.54,
    bonus: 'Up to A$365 Daily Free Bonus',
    games: '4,250+',
    gameLibrary: {
      totalGames: '4,250+',
      providers: '50+',
      exclusives: '16+',
      liveTables: '5+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/micky9.png',
    featured: true,
    tags: ['Best AUS', 'Best for Games'],
    pros: ['Balanced game portfolio', 'Simple and clean UX', 'Fast and predictable cashouts', 'Stable customer support'],
    cons: ['Exclusive title count is lower than specialist game hubs', 'Weekly promo mix is consistent but not very diverse'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 95,
      bonuses: 92,
      games: 94,
      support: 95
    },
    editorNote: 'Micky9 is one of the most balanced platforms in this list, offering clean UX, steady withdrawals, and reliable service across the full player journey.',
  },
  {
    rank: 14,
    name: 'Queen13 Online Casino',
    description: 'Queen13 positions itself as a premium destination with high-limit options, polished lobby design, and VIP-oriented service quality. It is built for players seeking a more upscale environment with strong reliability fundamentals.',
    rating: 4.52,
    bonus: 'New Registration Free $113 + $68 Free Chips',
    games: '4,350+',
    gameLibrary: {
      totalGames: '4,350+',
      providers: '50+',
      exclusives: '20+',
      liveTables: '14+'
    },
    minDeposit: '$10',
    payoutSpeed: '15 mins - 24 hrs',
    logo: '/casino-logo/queen13.png',
    featured: true,
    tags: ['Top Picks', 'Best AUS', 'Best for Games'],
    pros: ['Royal-style premium lobby', 'High-quality VIP treatment', 'Strong live table coverage', 'Reliable withdrawal timeline'],
    cons: ['Premium campaigns often include stricter wagering conditions', 'Several high-end VIP perks unlock only after sustained play volume'],
    licenses: ['Curacao Gaming Authority (CGA)', 'PAGCOR'],
    paymentMethods: ['Visa', 'Mastercard', 'Apple Pay', 'Google Pay', 'PayID', 'Osko', 'Amopay'],
    softwareProviders: ['Bng', 'JILI', 'VPower', 'Pragmatic Play', 'CQ9', 'Rich Gaming', 'WF Gaming', 'Pegasus', 'MEGA H5', 'ACE333'],
    trustScore: {
      safety: 97,
      bonuses: 94,
      games: 95,
      support: 95
    },
    editorNote: 'Queen13 justifies its premium positioning with strong trust metrics, polished delivery, and a consistently high-quality VIP-oriented experience.',
  },
];